module.exports = __webpack_public_path__ + "img/download.147270b8.png";